import api from "./api";

let _cache = null;
let _inflight = null;

export const loadSettings = async () => {
    if (_cache) return _cache;
    if (_inflight) return _inflight;
    _inflight = (async () => {
        try {
            const { data } = await api.get("/settings");
            _cache = data;
            return data;
        } catch (e) {
            return { firma_datore: null };
        } finally {
            _inflight = null;
        }
    })();
    return _inflight;
};

export const loadPublicSettings = async () => {
    try {
        const { data } = await api.get("/settings/public");
        return data;
    } catch (e) {
        return { firma_datore: null };
    }
};

export const updateSettings = async (settings) => {
    const { data } = await api.put("/settings", settings);
    _cache = data;
    return data;
};

export const invalidateSettings = () => {
    _cache = null;
};

export const getVerifyBaseUrl = () => {
    // Follow the domain the app is being used from (hr.splendorsud.com in production)
    return window.location.origin || process.env.REACT_APP_BACKEND_URL;
};
